var _defs, _text, _text2, _text3, _text4, _text5, _text6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _g, _rect8, _rect9, _text7, _rect10, _rect11, _text8, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _rect12, _path9, _rect13, _rect14, _path10, _rect15, _path11, _path12, _rect16, _path13, _rect17, _rect18, _path14, _rect19, _path15, _path16, _rect20, _path17, _rect21, _rect22, _path18, _rect23, _g4, _g5, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _g6, _path25, _path26, _g7, _path27, _path28, _path29, _path30, _g8, _g9, _text9, _text10, _rect24, _text11, _rect25, _text12, _path31, _path32, _path33, _rect26, _rect27, _text13, _rect28, _rect29, _text14, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 847.229,
    height: 353.175,
    viewBox: "0 0 847.229 353.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.5,
    y1: 0.5,
    x2: -2.43,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -7.613,
    y1: 0.5,
    x2: -0.332,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.71,
    y1: 0.497,
    x2: 2.309,
    y2: 0.504,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 7.54,
    y1: 0.499,
    x2: 2.373,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3.964,
    y1: 0.498,
    x2: 2.263,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -4.51,
    y1: 0.498,
    x2: 2.479,
    y2: 0.501,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.139,
    y1: 0.729,
    x2: 0.441,
    y2: 0.436,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.007,
    y1: 0.477,
    x2: 0.713,
    y2: 0.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.159,
    y1: 0.193,
    x2: 0.121,
    y2: 0.401,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3175",
    "data-name": "\\uD328\\uC2A4 3175",
    d: "M478.738,6505.968v7.149c0,.634-1.107,1.268-3.32,1.751a44.644,44.644,0,0,1-16.027,0c-2.213-.483-3.32-1.117-3.32-1.751v-7.149Z",
    fill: "#d0d2d3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3177",
    "data-name": "\\uD328\\uC2A4 3177",
    d: "M474.774,6487.3v18.615c0,.412-.719.824-2.158,1.138a29,29,0,0,1-10.423,0c-1.439-.314-2.158-.726-2.158-1.138V6487.3Z",
    fill: "#d0d2d3"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\uC801\\uC0B0\\uC5F4\\uB7C9\\uACC4",
    transform: "translate(712.729 221.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC801\uC0B0\uC5F4\uB7C9\uACC4"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "\\uCD95\\uC5F4\\uC870",
    transform: "translate(567.729 350.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCD95\uC5F4\uC870"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC5F4\\uB9E4\\uCCB4_\\uC21C\\uD658\\uD38C\\uD504",
    "data-name": "\\uC5F4\\uB9E4\\uCCB4 \\uC21C\\uD658\\uD38C\\uD504",
    transform: "translate(181.729 347.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC5F4\uB9E4\uCCB4 \uC21C\uD658\uD38C\uD504"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "\\uAC8C\\uC774\\uD2B8\\uBC38\\uBE0C",
    transform: "translate(53.729 347.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uAC8C\uC774\uD2B8\uBC38\uBE0C"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC9D1\\uC5F4\\uAE30",
    transform: "translate(187.729 193.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC9D1\uC5F4\uAE30"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC555\\uB825\\uACC4",
    transform: "translate(424.729 173.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC555\uB825\uACC4"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_583",
    "data-name": "\\uC0AC\\uAC01\\uD615 583",
    width: 11,
    height: 174,
    transform: "translate(829 172) rotate(90)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_584",
    "data-name": "\\uC0AC\\uAC01\\uD615 584",
    width: 11,
    height: 18,
    transform: "translate(846 172) rotate(90)",
    fill: "#0071bc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_585",
    "data-name": "\\uC0AC\\uAC01\\uD615 585",
    width: 11,
    height: 178,
    transform: "translate(833 133) rotate(90)",
    fill: "url(#linear-gradient-2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_586",
    "data-name": "\\uC0AC\\uAC01\\uD615 586",
    width: 11,
    height: 53,
    transform: "translate(537 223) rotate(90)",
    fill: "url(#linear-gradient-3)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_587",
    "data-name": "\\uC0AC\\uAC01\\uD615 587",
    width: 11.562,
    height: 238,
    transform: "translate(607 274.719) rotate(90)",
    fill: "url(#linear-gradient-4)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_588",
    "data-name": "\\uC0AC\\uAC01\\uD615 588",
    width: 11.562,
    height: 98,
    transform: "translate(154 105.719) rotate(90)",
    fill: "url(#linear-gradient-5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_589",
    "data-name": "\\uC0AC\\uAC01\\uD615 589",
    width: 11.562,
    height: 110,
    transform: "translate(370 105.719) rotate(90)",
    fill: "url(#linear-gradient-6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3054",
    "data-name": "\\uD328\\uC2A4 3054",
    d: "M735.529,6583.021l14.5-9.151-14.5-9.392Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#f44522"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3055",
    "data-name": "\\uD328\\uC2A4 3055",
    d: "M1084.529,6493.021l14.5-9.151-14.5-9.392Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#f44522"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3056",
    "data-name": "\\uD328\\uC2A4 3056",
    d: "M1086.529,6512.923l-14.5,9.152,14.5,9.391Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#0071bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1491",
    "data-name": "\\uADF8\\uB8F9 1491",
    transform: "translate(-255.529 -6345.195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_590",
    "data-name": "\\uC0AC\\uAC01\\uD615 590",
    width: 13,
    height: 11,
    transform: "translate(1037.529 6515.418) rotate(90)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_591",
    "data-name": "\\uC0AC\\uAC01\\uD615 591",
    width: 13,
    height: 11,
    transform: "translate(986.529 6515.417) rotate(90)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1490",
    "data-name": "\\uADF8\\uB8F9 1490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3057",
    "data-name": "\\uD328\\uC2A4 3057",
    d: "M1028.557,6527.714H983.328a1.97,1.97,0,0,1-1.972-1.972v-7.734a1.971,1.971,0,0,1,1.972-1.973h45.229a1.973,1.973,0,0,1,1.972,1.973v7.734a1.973,1.973,0,0,1-1.972,1.972Z",
    fill: "#ed0611"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3058",
    "data-name": "\\uD328\\uC2A4 3058",
    d: "M1005.942,6499.227a21.86,21.86,0,0,0-13.721,38.929l-1.054,2.706a.566.566,0,0,0,.288.718l8.423,3.93a.565.565,0,0,0,.735-.241l1.449-2.64a22.128,22.128,0,0,0,3.88.341,21.872,21.872,0,1,0,0-43.743Zm-10.561,42.46a.439.439,0,1,1-.212-.584A.439.439,0,0,1,995.381,6541.687Zm2.689,1.255a.44.44,0,1,1-.212-.584A.438.438,0,0,1,998.07,6542.942Z",
    fill: "#ff0714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3059",
    "data-name": "\\uD328\\uC2A4 3059",
    d: "M1025.154,6521.1a19.212,19.212,0,1,1-19.212-19.164A19.189,19.189,0,0,1,1025.154,6521.1Z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3060",
    "data-name": "\\uD328\\uC2A4 3060",
    d: "M1026.484,6518.719h-12.233a.946.946,0,0,0-.632.227.645.645,0,0,0-.2.291l-1.609,5.1a6,6,0,0,1-11.739,0l-1.614-5.109a.7.7,0,0,0-.3-.367.972.972,0,0,0-.529-.149H985.4a20.671,20.671,0,0,1,41.083,0Z",
    fill: "#e0e3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3061",
    "data-name": "\\uD328\\uC2A4 3061",
    d: "M1026.118,6516.532h-11.867a3.139,3.139,0,0,0-2.082.776,2.833,2.833,0,0,0-.831,1.269l-1.658,5.255a3.812,3.812,0,0,1-7.473,0l-1.66-5.26a2.88,2.88,0,0,0-1.194-1.544,3.186,3.186,0,0,0-1.719-.5H985.766a20.671,20.671,0,0,1,40.352,0Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_39",
    "data-name": "\\uD0C0\\uC6D0 39",
    cx: 3.319,
    cy: 3.319,
    r: 3.319,
    transform: "translate(1002.624 6518.913)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_40",
    "data-name": "\\uD0C0\\uC6D0 40",
    cx: 1.77,
    cy: 1.77,
    r: 1.77,
    transform: "translate(1004.172 6520.461)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1475",
    "data-name": "\\uADF8\\uB8F9 1475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1474",
    "data-name": "\\uADF8\\uB8F9 1474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3062",
    "data-name": "\\uD328\\uC2A4 3062",
    d: "M1026.722,6518.765a20.911,20.911,0,0,0-41.56,0,21.4,21.4,0,0,0-.128,2.332,20.908,20.908,0,1,0,41.817,0A21.4,21.4,0,0,0,1026.722,6518.765Zm-20.78,21.5a19.166,19.166,0,1,1,19.212-19.167A19.189,19.189,0,0,1,1005.942,6540.264Z",
    fill: "#ed0611"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1476",
    "data-name": "\\uADF8\\uB8F9 1476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3063",
    "data-name": "\\uD328\\uC2A4 3063",
    d: "M1019.164,6513.451l.3-1.319h.609v1.858h-.414v-1.333l-.3,1.333h-.414l-.326-1.314v1.314h-.382v-1.858h.609Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3064",
    "data-name": "\\uD328\\uC2A4 3064",
    d: "M1020.9,6511.554a.134.134,0,0,0-.043-.117.188.188,0,0,0-.114-.031.206.206,0,0,0-.115.029.111.111,0,0,0-.043.1v.083h-.286v-.07a.279.279,0,0,1,.114-.24.722.722,0,0,1,.676,0,.279.279,0,0,1,.114.24v.033a.255.255,0,0,1-.212.265.293.293,0,0,1,.164.1.288.288,0,0,1,.048.168v.1a.281.281,0,0,1-.114.241.73.73,0,0,1-.676,0,.281.281,0,0,1-.114-.241v-.106h.286v.119a.112.112,0,0,0,.043.1.206.206,0,0,0,.115.028.2.2,0,0,0,.114-.029.132.132,0,0,0,.043-.116v-.1a.155.155,0,0,0-.047-.128.252.252,0,0,0-.152-.036h-.1v-.184h.119a.256.256,0,0,0,.134-.03.116.116,0,0,0,.048-.107Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1483",
    "data-name": "\\uADF8\\uB8F9 1483"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_592",
    "data-name": "\\uC0AC\\uAC01\\uD615 592",
    width: 2.737,
    height: 3.079,
    transform: "translate(994.295 6511.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1477",
    "data-name": "\\uADF8\\uB8F9 1477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3065",
    "data-name": "\\uD328\\uC2A4 3065",
    d: "M995,6512.055a.456.456,0,0,1,.17-.38.98.98,0,0,1,.982,0,.456.456,0,0,1,.17.38v1.057a.454.454,0,0,1-.17.379.98.98,0,0,1-.982,0,.454.454,0,0,1-.17-.379Zm.435,1.077a.182.182,0,0,0,.062.156.322.322,0,0,0,.328,0,.181.181,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.155.322.322,0,0,0-.328,0,.181.181,0,0,0-.062.155Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_593",
    "data-name": "\\uC0AC\\uAC01\\uD615 593",
    width: 2.737,
    height: 3.079,
    transform: "translate(997.232 6511.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1478",
    "data-name": "\\uADF8\\uB8F9 1478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3066",
    "data-name": "\\uD328\\uC2A4 3066",
    d: "M997.939,6512.055a.454.454,0,0,1,.171-.38.98.98,0,0,1,.982,0,.456.456,0,0,1,.17.38v1.057a.454.454,0,0,1-.17.379.98.98,0,0,1-.982,0,.452.452,0,0,1-.171-.379Zm.436,1.077a.181.181,0,0,0,.061.156.324.324,0,0,0,.329,0,.181.181,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.155.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.155Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_594",
    "data-name": "\\uC0AC\\uAC01\\uD615 594",
    width: 2.737,
    height: 3.079,
    transform: "translate(1000.169 6511.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1479",
    "data-name": "\\uADF8\\uB8F9 1479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3067",
    "data-name": "\\uD328\\uC2A4 3067",
    d: "M1000.876,6512.055a.456.456,0,0,1,.17-.38.98.98,0,0,1,.982,0,.453.453,0,0,1,.17.38v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.454.454,0,0,1-.17-.379Zm.436,1.077a.181.181,0,0,0,.061.156.274.274,0,0,0,.164.045.27.27,0,0,0,.164-.045.182.182,0,0,0,.062-.156v-1.1a.181.181,0,0,0-.062-.155.27.27,0,0,0-.164-.045.274.274,0,0,0-.164.045.18.18,0,0,0-.061.155Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_595",
    "data-name": "\\uC0AC\\uAC01\\uD615 595",
    width: 2.737,
    height: 3.079,
    transform: "translate(1003.105 6511.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1480",
    "data-name": "\\uADF8\\uB8F9 1480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3068",
    "data-name": "\\uD328\\uC2A4 3068",
    d: "M1003.813,6512.055a.454.454,0,0,1,.17-.38.98.98,0,0,1,.982,0,.456.456,0,0,1,.17.38v1.057a.454.454,0,0,1-.17.379.98.98,0,0,1-.982,0,.452.452,0,0,1-.17-.379Zm.435,1.077a.182.182,0,0,0,.062.156.27.27,0,0,0,.164.045.274.274,0,0,0,.164-.045.181.181,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.155.274.274,0,0,0-.164-.045.27.27,0,0,0-.164.045.181.181,0,0,0-.062.155Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_596",
    "data-name": "\\uC0AC\\uAC01\\uD615 596",
    width: 2.737,
    height: 3.079,
    transform: "translate(1006.042 6511.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1481",
    "data-name": "\\uADF8\\uB8F9 1481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3069",
    "data-name": "\\uD328\\uC2A4 3069",
    d: "M1006.749,6512.055a.456.456,0,0,1,.17-.38.98.98,0,0,1,.982,0,.454.454,0,0,1,.171.38v1.057a.452.452,0,0,1-.171.379.98.98,0,0,1-.982,0,.454.454,0,0,1-.17-.379Zm.436,1.077a.181.181,0,0,0,.061.156.324.324,0,0,0,.329,0,.181.181,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.155.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.155Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_597",
    "data-name": "\\uC0AC\\uAC01\\uD615 597",
    width: 2.737,
    height: 3.079,
    transform: "translate(1008.979 6511.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1482",
    "data-name": "\\uADF8\\uB8F9 1482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3070",
    "data-name": "\\uD328\\uC2A4 3070",
    d: "M1009.686,6512.055a.456.456,0,0,1,.17-.38.98.98,0,0,1,.982,0,.456.456,0,0,1,.17.38v1.057a.454.454,0,0,1-.17.379.98.98,0,0,1-.982,0,.454.454,0,0,1-.17-.379Zm.436,1.077a.181.181,0,0,0,.061.156.322.322,0,0,0,.328,0,.182.182,0,0,0,.062-.156v-1.1a.181.181,0,0,0-.062-.155.322.322,0,0,0-.328,0,.18.18,0,0,0-.061.155Z",
    fill: "#f14941"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_598",
    "data-name": "\\uC0AC\\uAC01\\uD615 598",
    width: 2.737,
    height: 3.079,
    transform: "translate(1011.915 6511.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_599",
    "data-name": "\\uC0AC\\uAC01\\uD615 599",
    width: 2.737,
    height: 3.08,
    transform: "translate(1014.852 6511.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_600",
    "data-name": "\\uC0AC\\uAC01\\uD615 600",
    width: 2.737,
    height: 0.429,
    transform: "translate(994.295 6511.044)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_601",
    "data-name": "\\uC0AC\\uAC01\\uD615 601",
    width: 2.737,
    height: 0.429,
    transform: "translate(997.232 6511.044)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_602",
    "data-name": "\\uC0AC\\uAC01\\uD615 602",
    width: 2.737,
    height: 0.429,
    transform: "translate(1000.169 6511.044)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_603",
    "data-name": "\\uC0AC\\uAC01\\uD615 603",
    width: 2.737,
    height: 0.429,
    transform: "translate(1003.105 6511.044)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_604",
    "data-name": "\\uC0AC\\uAC01\\uD615 604",
    width: 2.737,
    height: 0.429,
    transform: "translate(1006.042 6511.044)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_605",
    "data-name": "\\uC0AC\\uAC01\\uD615 605",
    width: 2.737,
    height: 0.429,
    transform: "translate(1008.979 6511.044)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_606",
    "data-name": "\\uC0AC\\uAC01\\uD615 606",
    width: 2.737,
    height: 0.429,
    transform: "translate(1011.915 6511.044)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3071",
    "data-name": "\\uD328\\uC2A4 3071",
    d: "M1013.486,6512.07a.233.233,0,0,0-.058-.185.236.236,0,0,0-.153-.047.241.241,0,0,0-.153.045.186.186,0,0,0-.057.155v.131h-.384v-.111a.474.474,0,0,1,.153-.379.838.838,0,0,1,.9,0,.474.474,0,0,1,.154.379v.053a.4.4,0,0,1-.285.418.384.384,0,0,1,.22.161.515.515,0,0,1,.065.266v.16a.475.475,0,0,1-.154.379.841.841,0,0,1-.9,0,.474.474,0,0,1-.153-.379v-.169h.384v.189a.185.185,0,0,0,.057.155.241.241,0,0,0,.153.045.236.236,0,0,0,.153-.046.226.226,0,0,0,.058-.183v-.16a.261.261,0,0,0-.063-.2.293.293,0,0,0-.2-.058h-.137v-.291h.159a.3.3,0,0,0,.179-.046.2.2,0,0,0,.065-.169Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3072",
    "data-name": "\\uD328\\uC2A4 3072",
    d: "M1016.665,6513.429a.831.831,0,0,0-.9,0,.475.475,0,0,0-.153.379v.11h.383v-.13a.188.188,0,0,1,.057-.155.236.236,0,0,1,.153-.047.191.191,0,0,1,.21.233v.112a.2.2,0,0,1-.064.171.155.155,0,0,1-.042.022h.445a.466.466,0,0,0,.068-.263v-.053A.469.469,0,0,0,1016.665,6513.429Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3073",
    "data-name": "\\uD328\\uC2A4 3073",
    d: "M1016.116,6511.044a.338.338,0,0,1-.049.051.371.371,0,0,1-.119.057.689.689,0,0,1-.186.02v.233h.3v1.586h.389v-1.947Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3074",
    "data-name": "\\uD328\\uC2A4 3074",
    d: "M1014.852,6511.044v.429h2.737v-.429Z",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3075",
    "data-name": "\\uD328\\uC2A4 3075",
    d: "M1016.452,6511.044v.429h-.39v-.069h-.3v-.232a.72.72,0,0,0,.186-.02.367.367,0,0,0,.12-.057.381.381,0,0,0,.048-.051Z",
    fill: "#b9362f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1484",
    "data-name": "\\uADF8\\uB8F9 1484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3076",
    "data-name": "\\uD328\\uC2A4 3076",
    d: "M1000.379,6509.095h-1.026l-.009-4.661h1.039Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_607",
    "data-name": "\\uC0AC\\uAC01\\uD615 607",
    width: 1.022,
    height: 4.661,
    transform: "translate(1003.428 6504.434)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_608",
    "data-name": "\\uC0AC\\uAC01\\uD615 608",
    width: 0.799,
    height: 4.661,
    transform: "translate(1000.949 6504.434)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3077",
    "data-name": "\\uD328\\uC2A4 3077",
    d: "M1008.812,6509.1h-.785s.012-4.023,0-4.661h.787Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3078",
    "data-name": "\\uD328\\uC2A4 3078",
    d: "M1006.481,6509.1h-.765s.011-3.108,0-4.661h.768Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3079",
    "data-name": "\\uD328\\uC2A4 3079",
    d: "M1012.541,6509.1h-.562l0-4.661h.56S1012.536,6507.541,1012.541,6509.1Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_609",
    "data-name": "\\uC0AC\\uAC01\\uD615 609",
    width: 0.548,
    height: 4.661,
    transform: "translate(1002.328 6504.434)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_610",
    "data-name": "\\uC0AC\\uAC01\\uD615 610",
    width: 0.551,
    height: 4.661,
    transform: "translate(1010.032 6504.434)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3080",
    "data-name": "\\uD328\\uC2A4 3080",
    d: "M1011.507,6509.1h-.555c0-1.554,0-4.661,0-4.661h.553Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_611",
    "data-name": "\\uC0AC\\uAC01\\uD615 611",
    width: 0.338,
    height: 4.661,
    transform: "translate(1007.068 6504.434)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_612",
    "data-name": "\\uC0AC\\uAC01\\uD615 612",
    width: 0.303,
    height: 4.661,
    transform: "translate(1004.927 6504.434)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_613",
    "data-name": "\\uC0AC\\uAC01\\uD615 613",
    width: 0.278,
    height: 4.661,
    transform: "translate(1009.291 6504.434)",
    fill: "#191917"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1489",
    "data-name": "\\uADF8\\uB8F9 1489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1486",
    "data-name": "\\uADF8\\uB8F9 1486"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_41",
    "data-name": "\\uD0C0\\uC6D0 41",
    cx: 2.82,
    cy: 2.82,
    r: 2.82,
    transform: "translate(1015.266 6522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3081",
    "data-name": "\\uD328\\uC2A4 3081",
    d: "M1018.086,6523.223a1.6,1.6,0,0,0-1.021,2.827l-.287.763a.157.157,0,0,0,.1.185.148.148,0,0,0,.184-.024l.517-.64a1.6,1.6,0,1,0,.51-3.111Z",
    fill: "#f22723"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1485",
    "data-name": "\\uADF8\\uB8F9 1485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3082",
    "data-name": "\\uD328\\uC2A4 3082",
    d: "M1018.087,6528.54a3.768,3.768,0,0,1-.458-.028l.043-.354a3.407,3.407,0,0,0,.669.015l.027.356C1018.275,6528.536,1018.181,6528.54,1018.087,6528.54Zm.648-.057-.061-.351a3.345,3.345,0,0,0,.643-.182l.131.333A3.674,3.674,0,0,1,1018.735,6528.483Zm-1.472-.034a3.769,3.769,0,0,1-.7-.235l.146-.326a3.35,3.35,0,0,0,.635.212Zm2.523-.319-.163-.318a3.371,3.371,0,0,0,.561-.364l.223.279A3.708,3.708,0,0,1,1019.786,6528.13Zm-3.555-.085a3.747,3.747,0,0,1-.6-.432l.235-.268a3.347,3.347,0,0,0,.544.39Zm4.454-.563-.25-.256a3.364,3.364,0,0,0,.431-.512l.295.2A3.791,3.791,0,0,1,1020.685,6527.482Zm-5.321-.127a3.78,3.78,0,0,1-.449-.589l.3-.187a3.306,3.306,0,0,0,.405.532Zm5.99-.756-.314-.171a3.348,3.348,0,0,0,.26-.617l.341.1A3.73,3.73,0,0,1,1021.354,6526.6Zm-6.616-.158a3.711,3.711,0,0,1-.255-.7l.346-.088a3.356,3.356,0,0,0,.23.628Zm6.995-.884-.35-.07a3.445,3.445,0,0,0,.066-.666l.357-.015v.015A3.782,3.782,0,0,1,1021.733,6525.557Zm-7.324-.175a3.762,3.762,0,0,1-.042-.561c0-.06,0-.119,0-.178l.357.017c0,.053,0,.107,0,.161a3.46,3.46,0,0,0,.038.508Zm7.022-.91a3.33,3.33,0,0,0-.135-.655l.341-.107a3.671,3.671,0,0,1,.149.726Zm-6.671-.146-.353-.052a3.7,3.7,0,0,1,.181-.718l.335.122A3.418,3.418,0,0,0,1014.76,6524.326Zm6.42-.823a3.3,3.3,0,0,0-.322-.586l.294-.2a3.777,3.777,0,0,1,.357.649Zm-6.127-.134-.322-.155a3.743,3.743,0,0,1,.385-.632l.285.215A3.313,3.313,0,0,0,1015.053,6523.369Zm5.6-.719a3.544,3.544,0,0,0-.481-.466l.221-.279a3.67,3.67,0,0,1,.532.515Zm-5.039-.11-.262-.242a3.763,3.763,0,0,1,.553-.492l.21.29A3.291,3.291,0,0,0,1015.616,6522.54Zm4.285-.55a3.376,3.376,0,0,0-.6-.3l.129-.333a3.665,3.665,0,0,1,.66.336Zm-3.5-.077-.179-.309a3.788,3.788,0,0,1,.673-.307l.115.339A3.308,3.308,0,0,0,1016.4,6521.913Zm2.589-.333a3.406,3.406,0,0,0-.659-.113l.025-.356a3.679,3.679,0,0,1,.73.125Zm-1.658-.036-.08-.348a3.782,3.782,0,0,1,.734-.093l.01.357A3.365,3.365,0,0,0,1017.328,6521.544Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1488",
    "data-name": "\\uADF8\\uB8F9 1488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3083",
    "data-name": "\\uD328\\uC2A4 3083",
    d: "M994.859,6525.181a1.108,1.108,0,0,0,0-.719,1.236,1.236,0,1,0-.219-.38,1.113,1.113,0,0,0-.623-.36,8.356,8.356,0,0,0-.219-2.452,8.319,8.319,0,0,0-.219,2.452,1.106,1.106,0,0,0-.623.36,1.236,1.236,0,1,0-.22.38,1.108,1.108,0,0,0,0,.719,1.236,1.236,0,1,0,.22.38,1.117,1.117,0,0,0,.623.36,8.309,8.309,0,0,0,.219,2.451,8.346,8.346,0,0,0,.219-2.451,1.124,1.124,0,0,0,.623-.36,1.236,1.236,0,1,0,.219-.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1487",
    "data-name": "\\uADF8\\uB8F9 1487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3084",
    "data-name": "\\uD328\\uC2A4 3084",
    d: "M993.8,6528.54a3.719,3.719,0,1,1,3.718-3.719A3.723,3.723,0,0,1,993.8,6528.54Zm0-7.279a3.56,3.56,0,1,0,3.56,3.56A3.565,3.565,0,0,0,993.8,6521.261Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_614",
    "data-name": "\\uC0AC\\uAC01\\uD615 614",
    width: 12.243,
    height: 1.918,
    transform: "translate(999.821 6532.183)",
    fill: "#e8ebdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_615",
    "data-name": "\\uC0AC\\uAC01\\uD615 615",
    width: 11.063,
    height: 1.918,
    transform: "translate(1000.411 6534.894)",
    fill: "#e8ebdd"
  })))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_616",
    "data-name": "\\uC0AC\\uAC01\\uD615 616",
    width: 34,
    height: 16,
    transform: "translate(667 130)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_617",
    "data-name": "\\uC0AC\\uAC01\\uD615 617",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(671 133)",
    fill: "#fff"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "T6",
    transform: "translate(679.053 141.698)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T6"))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_618",
    "data-name": "\\uC0AC\\uAC01\\uD615 618",
    width: 34,
    height: 16,
    transform: "translate(667 169.5)",
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_619",
    "data-name": "\\uC0AC\\uAC01\\uD615 619",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(671 172.5)",
    fill: "#fff"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "T5",
    transform: "translate(679.053 181.198)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T5"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1493",
    "data-name": "\\uADF8\\uB8F9 1493",
    transform: "translate(-255.529 -6345.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3085",
    "data-name": "\\uD328\\uC2A4 3085",
    d: "M501.507,6348.759c-1.841,0-3.682-.02-5.522.011-.619.011-.858-.141-.871-.82-.053-2.743-.078-2.742,2.638-2.742,3.009,0,6.018.015,9.027-.013.649-.006.919.117.924.857.016,2.707.046,2.707-2.692,2.707Z",
    fill: "#fe9b38"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1492",
    "data-name": "\\uADF8\\uB8F9 1492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3086",
    "data-name": "\\uD328\\uC2A4 3086",
    d: "M555.058,6365.616c.011,3.507.015,7.013.039,10.519,0,.5-.087.759-.686.776a29.242,29.242,0,0,1-22.158-8.678,1.6,1.6,0,0,1-.179-.261,12.573,12.573,0,0,0,1.92-1.789c2.036-1.932,3.891-4.049,6.03-5.876.41,0,.586.356.861.565.841.639,1.659,1.317,2.546,1.887A18.912,18.912,0,0,0,555.058,6365.616Z",
    fill: "#fec24d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3087",
    "data-name": "\\uD328\\uC2A4 3087",
    d: "M540.024,6360.307c-2.139,1.827-3.994,3.944-6.03,5.876a12.573,12.573,0,0,1-1.92,1.789,28.354,28.354,0,0,1-8.029-15.005,32.217,32.217,0,0,1-.643-6.632c0-.641.114-.964.864-.954,3.472.043,6.944.034,10.416.044a22.152,22.152,0,0,0,1.241,8.066,15.913,15.913,0,0,0,4.1,6.4Z",
    fill: "#fee980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3088",
    "data-name": "\\uD328\\uC2A4 3088",
    d: "M540.024,6360.307q0-.21,0-.42c.486-.032.709-.438,1-.728,2.29-2.265,4.512-4.6,6.868-6.794q3.612-3.36,6.985-6.948c.261.108.206.344.206.544q-.012,9.828-.03,19.655a18.912,18.912,0,0,1-11.627-2.857c-.887-.57-1.705-1.248-2.546-1.887C540.61,6360.663,540.434,6360.309,540.024,6360.307Z",
    fill: "#fe9933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3089",
    "data-name": "\\uD328\\uC2A4 3089",
    d: "M554.882,6345.417q-3.375,3.593-6.985,6.948c-2.356,2.193-4.578,4.529-6.868,6.794-.293.29-.516.7-1,.728a15.913,15.913,0,0,1-4.1-6.4,22.152,22.152,0,0,1-1.241-8.066c4.336-.017,8.673-.041,13.009-.047C550.088,6345.375,552.485,6345.4,554.882,6345.417Z",
    fill: "#fec24d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3090",
    "data-name": "\\uD328\\uC2A4 3090",
    d: "M537.152,6390.385c.037-.093-.043.1-.117.3-1.72,4.548-3.451,9.092-5.146,13.649-.232.624-.447.8-1.124.537-2.518-.961-2.533-.935-1.58-3.436,1.531-4.016,3.092-8.021,4.581-12.053.269-.729.551-.845,1.2-.533.6.289,1.242.5,1.866.743C537.066,6389.68,537.331,6389.738,537.152,6390.385Z",
    fill: "#fe7936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3091",
    "data-name": "\\uD328\\uC2A4 3091",
    d: "M496.944,6372.195c-.165,0-.3-.016-.363-.178-.039-.1-.092-.191-.139-.285-1.3-2.6-1.3-2.6,1.334-3.691,3.944-1.628,7.892-3.249,11.827-4.9.585-.244.874-.272,1.164.429,1.026,2.479,1.064,2.474-1.419,3.505q-5.862,2.436-11.733,4.851C497.387,6372.021,497.157,6372.11,496.944,6372.195Z",
    fill: "#fe9a36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3092",
    "data-name": "\\uD328\\uC2A4 3092",
    d: "M554.964,6398.959c0,1.8-.016,3.609.009,5.413.009.585-.174.78-.783.8-2.726.075-2.726.1-2.726-2.654,0-2.972.02-5.944-.015-8.916-.007-.685.174-.907.882-.913,2.634-.023,2.634-.049,2.634,2.558Q554.965,6397.1,554.964,6398.959Z",
    fill: "#fe7835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3093",
    "data-name": "\\uD328\\uC2A4 3093",
    d: "M501.623,6398.2c-.188-.158-.366-.329-.566-.47-.618-.433-.547-.779-.016-1.3,3.366-3.316,6.721-6.644,10.016-10.03.767-.789,1.288-.892,1.93.015.121.17.27.32.406.479-.488.019-.716.42-1.006.71q-4.907,4.89-9.8,9.79A2.9,2.9,0,0,1,501.623,6398.2Z",
    fill: "#fe9b3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3094",
    "data-name": "\\uD328\\uC2A4 3094",
    d: "M501.623,6398.2a2.9,2.9,0,0,0,.963-.808q4.9-4.893,9.8-9.79c.29-.29.518-.691,1.006-.71.188.158.367.327.565.471.583.425.465.767-.013,1.238-3.112,3.07-6.2,6.168-9.288,9.257-.174.175-.35.348-.524.523C502.811,6399.71,502.811,6399.71,501.623,6398.2Z",
    fill: "#fe7a37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3095",
    "data-name": "\\uD328\\uC2A4 3095",
    d: "M516.046,6345.208c2.424,0,2.387,0,2.419,2.448.012.887-.264,1.188-1.145,1.132-1.056-.068-2.121-.037-3.181-.009-.549.015-.795-.182-.728-.735a.758.758,0,0,0,0-.106C513.32,6345.208,513.32,6345.208,516.046,6345.208Z",
    fill: "#fec452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3096",
    "data-name": "\\uD328\\uC2A4 3096",
    d: "M554.977,6384.5c0,2.6,0,2.582-2.627,2.557-.675-.007-.939-.173-.9-.892.059-1.16.033-2.326.009-3.489-.011-.5.154-.729.664-.67a2.544,2.544,0,0,0,.317,0C554.977,6381.978,554.977,6381.978,554.977,6384.5Z",
    fill: "#fe9b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3097",
    "data-name": "\\uD328\\uC2A4 3097",
    d: "M541.4,6380.209c-.579,1.388-1.131,2.727-1.7,4.058-.132.309-.37.2-.627.124-2.825-.833-2.862-.9-1.781-3.519.934-2.265.937-2.271,3.271-1.268C540.883,6379.739,541.355,6379.73,541.4,6380.209Z",
    fill: "#fe9b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3098",
    "data-name": "\\uD328\\uC2A4 3098",
    d: "M521.6,6361.718c.037.345-.27.389-.468.474-1.133.492-2.279.953-3.416,1.436-.448.19-.75.1-.9-.387a.679.679,0,0,0-.041-.1c-1.189-2.47-1.189-2.47,1.341-3.5,2.225-.907,2.226-.907,3.155,1.29C521.382,6361.192,521.488,6361.454,521.6,6361.718Z",
    fill: "#fec451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3099",
    "data-name": "\\uD328\\uC2A4 3099",
    d: "M517.4,6382.695a.445.445,0,0,1-.095-.045c-1.354-1.126-1.354-1.126-.153-2.322a22.62,22.62,0,0,0,1.626-1.649c.576-.705,1.058-.819,1.606-.008a5.659,5.659,0,0,0,.482.55A29.774,29.774,0,0,0,517.4,6382.695Z",
    fill: "#fec453"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3100",
    "data-name": "\\uD328\\uC2A4 3100",
    d: "M517.4,6382.695a29.774,29.774,0,0,1,3.466-3.474l1.292,1.2c-.986.962-1.975,1.826-2.836,2.8-.607.688-1.029.691-1.528-.033C517.677,6383.018,517.534,6382.86,517.4,6382.695Z",
    fill: "#fe9b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3101",
    "data-name": "\\uD328\\uC2A4 3101",
    d: "M528.307,6371.563c1.471,1.169,1.47,1.169.205,2.437a18.826,18.826,0,0,0-1.559,1.591c-.6.764-1.088.727-1.62-.028-.14-.2-.308-.382-.463-.572A28.878,28.878,0,0,0,528.307,6371.563Z",
    fill: "#fe9b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3102",
    "data-name": "\\uD328\\uC2A4 3102",
    d: "M528.307,6371.563a28.878,28.878,0,0,1-3.437,3.428c-.211-.182-.415-.373-.634-.544-.494-.384-.535-.732-.034-1.18.653-.585,1.248-1.235,1.869-1.856C527.224,6370.26,527.224,6370.26,528.307,6371.563Z",
    fill: "#fec453"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3103",
    "data-name": "\\uD328\\uC2A4 3103",
    d: "M311.529,6451.195h-25v89h11v-78h14Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "url(#linear-gradient-7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3104",
    "data-name": "\\uD328\\uC2A4 3104",
    d: "M297.529,6619.914v-78.719h-11v90.281h340v-11.562Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "url(#linear-gradient-8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3105",
    "data-name": "\\uD328\\uC2A4 3105",
    d: "M659.529,6568.195v-117h-34v11h23v117h89v-11Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "url(#linear-gradient-9)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1505",
    "data-name": "\\uADF8\\uB8F9 1505",
    transform: "translate(-255.529 -6345.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1504",
    "data-name": "\\uADF8\\uB8F9 1504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1496",
    "data-name": "\\uADF8\\uB8F9 1496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1494",
    "data-name": "\\uADF8\\uB8F9 1494"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_620",
    "data-name": "\\uC0AC\\uAC01\\uD615 620",
    width: 7.828,
    height: 28.726,
    transform: "translate(781.627 6656.836)",
    fill: "#8d8e8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1495",
    "data-name": "\\uADF8\\uB8F9 1495"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_621",
    "data-name": "\\uC0AC\\uAC01\\uD615 621",
    width: 7.834,
    height: 28.726,
    transform: "translate(906.938 6656.836)",
    fill: "#8d8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1497",
    "data-name": "\\uADF8\\uB8F9 1497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3106",
    "data-name": "\\uD328\\uC2A4 3106",
    d: "M905.6,6656.836c0-6.168-25.7-11.17-57.4-11.17s-57.391,5-57.391,11.17S816.5,6668,848.2,6668,905.6,6663,905.6,6656.836Z",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1498",
    "data-name": "\\uADF8\\uB8F9 1498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3107",
    "data-name": "\\uD328\\uC2A4 3107",
    d: "M917.12,6462.606c0-7.407-30.861-13.411-68.924-13.411s-68.917,6-68.917,13.411,30.856,13.411,68.917,13.411S917.12,6470.014,917.12,6462.606Z",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1503",
    "data-name": "\\uADF8\\uB8F9 1503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1499",
    "data-name": "\\uADF8\\uB8F9 1499"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_622",
    "data-name": "\\uC0AC\\uAC01\\uD615 622",
    width: 137.841,
    height: 194.26,
    transform: "translate(779.279 6462.606)",
    fill: "#9b9c9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1500",
    "data-name": "\\uADF8\\uB8F9 1500"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_623",
    "data-name": "\\uC0AC\\uAC01\\uD615 623",
    width: 137.841,
    height: 191.403,
    transform: "translate(779.279 6465.462)",
    fill: "#d5d5d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1501",
    "data-name": "\\uADF8\\uB8F9 1501"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_624",
    "data-name": "\\uC0AC\\uAC01\\uD615 624",
    width: 6.966,
    height: 191.389,
    transform: "translate(782.759 6465.447)",
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1502",
    "data-name": "\\uADF8\\uB8F9 1502"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_625",
    "data-name": "\\uC0AC\\uAC01\\uD615 625",
    width: 3.486,
    height: 191.389,
    transform: "translate(793.868 6465.447)",
    fill: "#eaeaea"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3108",
    "data-name": "\\uD328\\uC2A4 3108",
    d: "M914.59,6684.72h-7.47l-4.166,7.559h15.8Z",
    fill: "#8d8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3109",
    "data-name": "\\uD328\\uC2A4 3109",
    d: "M789.272,6684.72H781.8l-4.166,7.559h15.807Z",
    fill: "#8d8e8e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1507",
    "data-name": "\\uADF8\\uB8F9 1507",
    transform: "translate(-255.529 -6345.195)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3110",
    "data-name": "\\uD328\\uC2A4 3110",
    d: "M727.242,6605.147H702.927a1.476,1.476,0,0,1-1.476-1.476h0a1.476,1.476,0,0,1,1.476-1.476h24.315a1.476,1.476,0,0,1,1.476,1.476h0A1.476,1.476,0,0,1,727.242,6605.147Z",
    fill: "#51a2e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3111",
    "data-name": "\\uD328\\uC2A4 3111",
    d: "M727.242,6605.147H702.927c4.09.25,7.4.926,8.516,2.8h0v1.67h7.283v-1.67h0C719.356,6605.983,722.627,6605.252,727.242,6605.147Z",
    fill: "#4081b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3112",
    "data-name": "\\uD328\\uC2A4 3112",
    d: "M713.951,6608.195c0-1.768-2.633-3.048-7.862-3.048h-1.375c4.071,0,7.618,1.5,7.618,3.048v.8h1.621Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_626",
    "data-name": "\\uC0AC\\uAC01\\uD615 626",
    width: 13.362,
    height: 35.269,
    transform: "translate(697.45 6632.278) rotate(-90)",
    fill: "#fcd144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1506",
    "data-name": "\\uADF8\\uB8F9 1506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3113",
    "data-name": "\\uD328\\uC2A4 3113",
    d: "M721.417,6619.532a14.819,14.819,0,0,1-1.656.624h12.958v-.624Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3114",
    "data-name": "\\uD328\\uC2A4 3114",
    d: "M710.538,6619.532H697.45v.624h14.743A14.808,14.808,0,0,1,710.538,6619.532Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3115",
    "data-name": "\\uD328\\uC2A4 3115",
    d: "M709.3,6618.917h0a13.138,13.138,0,0,0,13.362,0H709.3Z",
    fill: "#dbdbdb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3116",
    "data-name": "\\uD328\\uC2A4 3116",
    d: "M708.4,6614.236h13.362v4.681a13.138,13.138,0,0,1-13.362,0Z",
    fill: "#e8c13e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3117",
    "data-name": "\\uD328\\uC2A4 3117",
    d: "M711.3,6620.156v-7.92h-1.622v7.311A14.8,14.8,0,0,0,711.3,6620.156Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_627",
    "data-name": "\\uC0AC\\uAC01\\uD615 627",
    width: 15.149,
    height: 4.001,
    transform: "translate(698.654 6633.172) rotate(-90)",
    fill: "#999"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_628",
    "data-name": "\\uC0AC\\uAC01\\uD615 628",
    width: 15.149,
    height: 4.001,
    transform: "translate(722.659 6614.236) rotate(180)",
    fill: "#999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_629",
    "data-name": "\\uC0AC\\uAC01\\uD615 629",
    d: "M0,0H10.546a0,0,0,0,1,0,0V.665a.578.578,0,0,1-.578.578H.578A.578.578,0,0,1,0,.665V0A0,0,0,0,1,0,0Z",
    transform: "translate(720.358 6610.236) rotate(180)",
    fill: "#a6a6a6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_630",
    "data-name": "\\uC0AC\\uAC01\\uD615 630",
    width: 15.149,
    height: 4.001,
    transform: "translate(727.514 6633.172) rotate(-90)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_631",
    "data-name": "\\uC0AC\\uAC01\\uD615 631",
    width: 1.622,
    height: 4.001,
    transform: "translate(708.785 6610.235)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3118",
    "data-name": "\\uD328\\uC2A4 3118",
    d: "M713.218,6608.992H711.6a.511.511,0,0,0-.511.511v.732h1.622v-.732A.51.51,0,0,1,713.218,6608.992Z",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3119",
    "data-name": "\\uD328\\uC2A4 3119",
    d: "M707.51,6605.147c-1.372,0-1.372-2.952,0-2.952h-3.021c-1.5,0-1.5,2.952,0,2.952Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_632",
    "data-name": "\\uC0AC\\uAC01\\uD615 632",
    width: 0.726,
    height: 15.168,
    transform: "translate(728.066 6618.014)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_633",
    "data-name": "\\uC0AC\\uAC01\\uD615 633",
    width: 0.726,
    height: 15.168,
    transform: "translate(699.204 6618.014)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1509",
    "data-name": "\\uADF8\\uB8F9 1509",
    transform: "translate(-255.529 -6345.195)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3120",
    "data-name": "\\uD328\\uC2A4 3120",
    d: "M591.242,6605.147H566.927a1.476,1.476,0,0,1-1.476-1.476h0a1.476,1.476,0,0,1,1.476-1.476h24.315a1.476,1.476,0,0,1,1.476,1.476h0A1.476,1.476,0,0,1,591.242,6605.147Z",
    fill: "#51a2e0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3121",
    "data-name": "\\uD328\\uC2A4 3121",
    d: "M591.242,6605.147H566.927c4.09.25,7.4.926,8.516,2.8h0v1.67h7.283v-1.67h0C583.356,6605.983,586.627,6605.252,591.242,6605.147Z",
    fill: "#4081b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3122",
    "data-name": "\\uD328\\uC2A4 3122",
    d: "M577.951,6608.195c0-1.768-2.633-3.048-7.862-3.048h-1.375c4.071,0,7.618,1.5,7.618,3.048v.8h1.621Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_634",
    "data-name": "\\uC0AC\\uAC01\\uD615 634",
    width: 13.362,
    height: 35.269,
    transform: "translate(561.45 6632.278) rotate(-90)",
    fill: "#fcd144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1508",
    "data-name": "\\uADF8\\uB8F9 1508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3123",
    "data-name": "\\uD328\\uC2A4 3123",
    d: "M585.417,6619.532a14.819,14.819,0,0,1-1.656.624h12.958v-.624Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3124",
    "data-name": "\\uD328\\uC2A4 3124",
    d: "M574.538,6619.532H561.45v.624h14.743A14.808,14.808,0,0,1,574.538,6619.532Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3125",
    "data-name": "\\uD328\\uC2A4 3125",
    d: "M573.3,6618.917h0a13.138,13.138,0,0,0,13.362,0H573.3Z",
    fill: "#dbdbdb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3126",
    "data-name": "\\uD328\\uC2A4 3126",
    d: "M572.4,6614.236h13.362v4.681a13.138,13.138,0,0,1-13.362,0Z",
    fill: "#e8c13e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3127",
    "data-name": "\\uD328\\uC2A4 3127",
    d: "M575.3,6620.156v-7.92h-1.622v7.311A14.8,14.8,0,0,0,575.3,6620.156Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_635",
    "data-name": "\\uC0AC\\uAC01\\uD615 635",
    width: 15.149,
    height: 4.001,
    transform: "translate(562.654 6633.172) rotate(-90)",
    fill: "#999"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_636",
    "data-name": "\\uC0AC\\uAC01\\uD615 636",
    width: 15.149,
    height: 4.001,
    transform: "translate(586.659 6614.236) rotate(180)",
    fill: "#999"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_637",
    "data-name": "\\uC0AC\\uAC01\\uD615 637",
    d: "M0,0H10.546a0,0,0,0,1,0,0V.665a.578.578,0,0,1-.578.578H.578A.578.578,0,0,1,0,.665V0A0,0,0,0,1,0,0Z",
    transform: "translate(584.358 6610.236) rotate(180)",
    fill: "#a6a6a6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_638",
    "data-name": "\\uC0AC\\uAC01\\uD615 638",
    width: 15.149,
    height: 4.001,
    transform: "translate(591.514 6633.172) rotate(-90)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_639",
    "data-name": "\\uC0AC\\uAC01\\uD615 639",
    width: 1.622,
    height: 4.001,
    transform: "translate(572.785 6610.235)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3128",
    "data-name": "\\uD328\\uC2A4 3128",
    d: "M577.218,6608.992H575.6a.511.511,0,0,0-.511.511v.732h1.622v-.732A.51.51,0,0,1,577.218,6608.992Z",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3129",
    "data-name": "\\uD328\\uC2A4 3129",
    d: "M571.51,6605.147c-1.372,0-1.372-2.952,0-2.952h-3.021c-1.5,0-1.5,2.952,0,2.952Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_640",
    "data-name": "\\uC0AC\\uAC01\\uD615 640",
    width: 0.726,
    height: 15.168,
    transform: "translate(592.066 6618.014)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_641",
    "data-name": "\\uC0AC\\uAC01\\uD615 641",
    width: 0.726,
    height: 15.168,
    transform: "translate(563.204 6618.014)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1511",
    "data-name": "\\uADF8\\uB8F9 1511",
    transform: "translate(-255.529 -6345.195)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3130",
    "data-name": "\\uD328\\uC2A4 3130",
    d: "M361.242,6605.147H336.927a1.476,1.476,0,0,1-1.476-1.476h0a1.476,1.476,0,0,1,1.476-1.476h24.315a1.476,1.476,0,0,1,1.476,1.476h0A1.476,1.476,0,0,1,361.242,6605.147Z",
    fill: "#51a2e0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3131",
    "data-name": "\\uD328\\uC2A4 3131",
    d: "M361.242,6605.147H336.927c4.09.25,7.4.926,8.516,2.8h0v1.67h7.283v-1.67h0C353.356,6605.983,356.627,6605.252,361.242,6605.147Z",
    fill: "#4081b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3132",
    "data-name": "\\uD328\\uC2A4 3132",
    d: "M347.951,6608.195c0-1.768-2.633-3.048-7.862-3.048h-1.375c4.071,0,7.618,1.5,7.618,3.048v.8h1.621Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_642",
    "data-name": "\\uC0AC\\uAC01\\uD615 642",
    width: 13.362,
    height: 35.269,
    transform: "translate(331.45 6632.278) rotate(-90)",
    fill: "#fcd144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1510",
    "data-name": "\\uADF8\\uB8F9 1510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3133",
    "data-name": "\\uD328\\uC2A4 3133",
    d: "M355.417,6619.532a14.819,14.819,0,0,1-1.656.624h12.958v-.624Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3134",
    "data-name": "\\uD328\\uC2A4 3134",
    d: "M344.538,6619.532H331.45v.624h14.743A14.806,14.806,0,0,1,344.538,6619.532Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3135",
    "data-name": "\\uD328\\uC2A4 3135",
    d: "M343.3,6618.917h0a13.138,13.138,0,0,0,13.362,0H343.3Z",
    fill: "#dbdbdb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3136",
    "data-name": "\\uD328\\uC2A4 3136",
    d: "M342.4,6614.236h13.362v4.681a13.138,13.138,0,0,1-13.362,0Z",
    fill: "#e8c13e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3137",
    "data-name": "\\uD328\\uC2A4 3137",
    d: "M345.3,6620.156v-7.92h-1.622v7.311A14.8,14.8,0,0,0,345.3,6620.156Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_643",
    "data-name": "\\uC0AC\\uAC01\\uD615 643",
    width: 15.149,
    height: 4.001,
    transform: "translate(332.654 6633.172) rotate(-90)",
    fill: "#999"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_644",
    "data-name": "\\uC0AC\\uAC01\\uD615 644",
    width: 15.149,
    height: 4.001,
    transform: "translate(356.659 6614.236) rotate(180)",
    fill: "#999"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_645",
    "data-name": "\\uC0AC\\uAC01\\uD615 645",
    d: "M0,0H10.546a0,0,0,0,1,0,0V.665a.578.578,0,0,1-.578.578H.578A.578.578,0,0,1,0,.665V0A0,0,0,0,1,0,0Z",
    transform: "translate(354.358 6610.236) rotate(180)",
    fill: "#a6a6a6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_646",
    "data-name": "\\uC0AC\\uAC01\\uD615 646",
    width: 15.149,
    height: 4.001,
    transform: "translate(361.514 6633.172) rotate(-90)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_647",
    "data-name": "\\uC0AC\\uAC01\\uD615 647",
    width: 1.622,
    height: 4.001,
    transform: "translate(342.785 6610.235)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3138",
    "data-name": "\\uD328\\uC2A4 3138",
    d: "M347.218,6608.992H345.6a.511.511,0,0,0-.511.511v.732h1.622v-.732A.51.51,0,0,1,347.218,6608.992Z",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3139",
    "data-name": "\\uD328\\uC2A4 3139",
    d: "M341.51,6605.147c-1.372,0-1.372-2.952,0-2.952h-3.021c-1.5,0-1.5,2.952,0,2.952Z",
    fill: "#424242",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_648",
    "data-name": "\\uC0AC\\uAC01\\uD615 648",
    width: 0.726,
    height: 15.168,
    transform: "translate(362.066 6618.014)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_649",
    "data-name": "\\uC0AC\\uAC01\\uD615 649",
    width: 0.726,
    height: 15.168,
    transform: "translate(333.204 6618.014)",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1513",
    "data-name": "\\uADF8\\uB8F9 1513",
    transform: "translate(-255.529 -6345.195)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_42",
    "data-name": "\\uD0C0\\uC6D0 42",
    cx: 17.88,
    cy: 17.88,
    r: 17.88,
    transform: "translate(636.081 6495.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1512",
    "data-name": "\\uADF8\\uB8F9 1512"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_650",
    "data-name": "\\uC0AC\\uAC01\\uD615 650",
    width: 9.119,
    height: 5.949,
    transform: "translate(649.301 6531.944)",
    fill: "#c4c5c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_651",
    "data-name": "\\uC0AC\\uAC01\\uD615 651",
    width: 4.56,
    height: 5.949,
    transform: "translate(649.301 6531.944)",
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_652",
    "data-name": "\\uC0AC\\uAC01\\uD615 652",
    width: 11.377,
    height: 2.302,
    transform: "translate(648.172 6537.894)",
    fill: "#f8931f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_653",
    "data-name": "\\uC0AC\\uAC01\\uD615 653",
    width: 2.562,
    height: 2.302,
    transform: "translate(656.987 6537.894)",
    fill: "#d37f1f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_654",
    "data-name": "\\uC0AC\\uAC01\\uD615 654",
    width: 2.562,
    height: 2.302,
    transform: "translate(648.172 6537.894)",
    fill: "#fcbf62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3140",
    "data-name": "\\uD328\\uC2A4 3140",
    d: "M653.86,6497.444a16.1,16.1,0,0,0-4.856.746l2.224,7.029a8.726,8.726,0,0,1,8.8,14.491l5.212,5.212a16.1,16.1,0,0,0-11.382-27.478",
    fill: "#ff2750",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3141",
    "data-name": "\\uD328\\uC2A4 3141",
    d: "M653.86,6497.444a16.1,16.1,0,0,0-4.856.746l.288.912a15.528,15.528,0,0,1,4.568-.685c8.849,0,16.024,7.422,16.031,16.58q.065-.72.065-1.457a16.1,16.1,0,0,0-16.1-16.1",
    fill: "#c84b47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3142",
    "data-name": "\\uD328\\uC2A4 3142",
    d: "M650.372,6497.824a16.057,16.057,0,0,0-7.893,4.335l5.211,5.211a8.7,8.7,0,0,1,4.279-2.35Z",
    fill: "#eac944",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3143",
    "data-name": "\\uD328\\uC2A4 3143",
    d: "M650.372,6497.824a16.057,16.057,0,0,0-7.893,4.335l.585.585a15.8,15.8,0,0,1,7.517-3.979Z",
    fill: "#d4b83d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3144",
    "data-name": "\\uD328\\uC2A4 3144",
    d: "M642.479,6502.159a16.094,16.094,0,0,0,0,22.763l5.211-5.212a8.725,8.725,0,0,1,0-12.34Z",
    fill: "#84bf55",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3145",
    "data-name": "\\uD328\\uC2A4 3145",
    d: "M642.479,6502.159a16.043,16.043,0,0,0-4.715,11.381q0,.736.065,1.457a16.818,16.818,0,0,1,5.235-12.253Z",
    fill: "#73af4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3146",
    "data-name": "\\uD328\\uC2A4 3146",
    d: "M652.927,6515.288a1.981,1.981,0,0,0,2.9-1.546c1.262-.789,2.613-.668,3.917-1.024.731-.207-.194-1.986-.676-2.7s-1.787-2.236-2.252-1.635c-.817,1.077-1.209,2.376-2.412,3.253a1.981,1.981,0,0,0-2.518,2.116l-10.605,8.188c-.07.047.018.176.087.13Z",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3147",
    "data-name": "\\uD328\\uC2A4 3147",
    d: "M657.881,6525.055h.081c.124,0,.176.055.176.185a.165.165,0,0,1-.174.189h-.083Zm-.414,1.292h.414v-.637h.109c.1,0,.136.046.136.227v.107a.821.821,0,0,0,.041.3h.441v-.022a.111.111,0,0,1-.047-.049.652.652,0,0,1-.02-.221v-.136c0-.212-.06-.339-.261-.356v0c.19-.029.272-.167.272-.379a.385.385,0,0,0-.437-.423h-.648Zm-.858-.8c0-.431.013-.546.14-.546s.141.115.141.546-.014.545-.141.545S656.609,6525.982,656.609,6525.552Zm-.428,0c0,.594.145.826.568.826s.568-.232.568-.826-.144-.827-.568-.827S656.181,6524.957,656.181,6525.552Zm-.773.8h.414v-1.239h.312v-.352H655.1v.352h.312Zm-.689-.591h-.232l.114-.675h.005Zm-.764.591h.441l.042-.279h.33l.043.279h.441l-.388-1.591h-.521Zm-.435-1.018h.4v-.1a.448.448,0,0,0-.514-.5c-.43,0-.569.218-.569.827,0,.592.1.826.569.826.265,0,.526-.107.526-.552v-.119h-.4c0,.3-.023.39-.125.39-.127,0-.141-.115-.141-.545s.014-.546.141-.546c.08,0,.113.053.113.234Zm-1.23,1.018h.415v-1.591h-.415Zm-1.263,0h.6c.48,0,.5-.379.5-.8s-.024-.8-.5-.8h-.6Zm.414-1.292h.083c.16,0,.18.066.18.5s-.02.5-.18.5h-.083Zm-1.733,1.292h.387v-.983h.005l.276.983h.455v-1.591h-.388v.98h-.005l-.267-.98h-.463Zm-.6,0h.414v-1.591h-.414Zm8.518-2.016h.962v-.338h-.548v-.317h.495v-.325h-.495v-.272h.528v-.339h-.942Zm-.865-1.292h.08c.125,0,.176.056.176.185,0,.114-.055.189-.174.189h-.082Zm-.414,1.292h.414v-.637h.109c.1,0,.136.047.136.227v.107a.836.836,0,0,0,.04.3h.441v-.022a.108.108,0,0,1-.046-.049.618.618,0,0,1-.021-.22v-.136c0-.212-.06-.339-.26-.357v0c.189-.029.272-.167.272-.379a.385.385,0,0,0-.437-.424h-.648Zm-1.257-1.591v1.043c0,.446.191.58.539.58s.539-.134.539-.58v-1.043h-.414v1.148c0,.154-.047.194-.125.194s-.125-.04-.125-.194v-1.148Zm-.172.46c0-.341-.154-.491-.515-.491a.454.454,0,0,0-.521.5c0,.564.651.408.651.722a.137.137,0,0,1-.134.154c-.08,0-.136-.049-.136-.185v-.038h-.4v.056c0,.33.192.448.535.448.365,0,.563-.152.563-.49,0-.582-.677-.428-.677-.743a.127.127,0,0,1,.129-.14c.08,0,.118.078.118.172v.038Zm-1.2,0c0-.341-.154-.491-.515-.491a.454.454,0,0,0-.522.5c0,.564.651.408.651.722a.137.137,0,0,1-.134.154c-.08,0-.136-.049-.136-.185v-.038h-.4v.056c0,.33.192.448.535.448.365,0,.564-.152.564-.49,0-.582-.678-.428-.678-.743a.128.128,0,0,1,.13-.14c.08,0,.118.078.118.172v.038Zm-2.122,1.131h.963v-.338h-.548v-.317h.494v-.325h-.494v-.272h.528v-.339H651.6Zm-.864-1.292h.08c.124,0,.176.056.176.185,0,.114-.056.189-.174.189h-.082Zm-.415,1.292h.415v-.637h.109c.1,0,.136.047.136.227v.107a.837.837,0,0,0,.04.3h.441v-.022a.106.106,0,0,1-.047-.049.648.648,0,0,1-.02-.22v-.136c0-.212-.06-.339-.261-.357v0c.19-.029.272-.167.272-.379a.385.385,0,0,0-.436-.424h-.649Zm-.8-1.292h.078c.1,0,.161.062.161.194s-.056.194-.161.194h-.078Zm-.414,1.292h.414v-.606h.145a.455.455,0,0,0,.521-.494.435.435,0,0,0-.458-.491h-.622Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3148",
    "data-name": "\\uD328\\uC2A4 3148",
    d: "M653.86,6512.272a1.268,1.268,0,1,0,1.268,1.268,1.268,1.268,0,0,0-1.268-1.268",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3149",
    "data-name": "\\uD328\\uC2A4 3149",
    d: "M653.86,6512.954a.586.586,0,1,0,.586.586.587.587,0,0,0-.586-.586",
    fill: "#bf9b0b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3150",
    "data-name": "\\uD328\\uC2A4 3150",
    d: "M647.045,6523.693a.792.792,0,1,1-.793.792.792.792,0,0,1,.793-.792",
    fill: "#f8931f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3151",
    "data-name": "\\uD328\\uC2A4 3151",
    d: "M660.675,6523.693a.792.792,0,1,1-.792.792.792.792,0,0,1,.792-.792",
    fill: "#f8931f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3152",
    "data-name": "\\uD328\\uC2A4 3152",
    d: "M642.9,6514.438h.418v-.493H642.9Zm-1.407,0h.463v-.471l.1-.149.272.62h.528l-.5-1,.448-.777H642.3l-.344.682h-.005v-.682h-.463Zm-.625,0h.418v-.493h-.418Zm-.872-.889c0-.481.015-.61.157-.61s.157.129.157.61-.015.61-.157.61S640,6514.029,640,6513.549Zm-.478,0c0,.665.162.924.635.924s.635-.259.635-.924-.162-.924-.635-.924S639.518,6512.884,639.518,6513.549Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3153",
    "data-name": "\\uD328\\uC2A4 3153",
    d: "M660.373,6501.806h.089c.139,0,.2.062.2.205,0,.126-.061.21-.192.21h-.092Zm-.46,1.433h.46v-.707h.121c.111,0,.151.052.151.252v.119a.917.917,0,0,0,.045.336h.489v-.025a.11.11,0,0,1-.052-.054.732.732,0,0,1-.022-.245v-.15c0-.235-.067-.376-.29-.4v-.005c.211-.032.3-.185.3-.42a.426.426,0,0,0-.484-.469h-.72Zm-1.235,0h1.068v-.376h-.608v-.351h.548v-.36h-.548v-.3h.585v-.375h-1.045Zm-.781-.647h.163c0,.308-.059.37-.155.37-.141,0-.156-.128-.156-.6s.015-.606.166-.606a.105.105,0,0,1,.106.077.641.641,0,0,1,.024.205h.445a.515.515,0,0,0-.558-.593c-.544,0-.658.326-.658.917s.042.917.509.917a.375.375,0,0,0,.381-.191h.005l.01.156h.311v-.959H657.9Zm-2.056.647h.43v-1.09h.005l.307,1.09h.5v-1.764h-.43v1.087h-.005l-.3-1.087h-.514Zm-.667-.655h-.257l.126-.749h0Zm-.848.655h.49l.047-.309h.365l.047.309h.49l-.43-1.764h-.579Zm-1.233,0h.668c.531,0,.558-.42.558-.882s-.027-.882-.558-.882h-.668Zm.46-1.433h.091c.178,0,.2.074.2.551s-.023.551-.2.551h-.091Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3154",
    "data-name": "\\uD328\\uC2A4 3154",
    d: "M653.86,6497.594a15.946,15.946,0,1,0,15.947,15.946,15.945,15.945,0,0,0-15.947-15.946m0-3.4a19.345,19.345,0,1,0,19.345,19.345A19.345,19.345,0,0,0,653.86,6494.195Z",
    fill: "#c4c5c6",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1521",
    "data-name": "\\uADF8\\uB8F9 1521",
    transform: "translate(-255.529 -6345.195)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1517",
    "data-name": "\\uADF8\\uB8F9 1517"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_655",
    "data-name": "\\uC0AC\\uAC01\\uD615 655",
    width: 31.674,
    height: 33.717,
    rx: 2.39,
    transform: "translate(503.59 6641.934) rotate(180)",
    fill: "#e5cd20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3155",
    "data-name": "\\uD328\\uC2A4 3155",
    d: "M466.808,6631.01s4.478-.015,5.108,3.657c.36-1.042,31.315-1.042,31.674,0,.631-3.672,5.109-3.657,5.109-3.657h1.022v-11.868H508.7s-4.478.015-5.109-3.657c-.046.135-.09.279-.132.428a17.658,17.658,0,0,0-31.459-.168c-.026-.089-.054-.177-.083-.26a4.24,4.24,0,0,1-.258.905c-.076.149-.149.3-.221.449-1.335,2.313-4.629,2.3-4.629,2.3h-1.022v11.868Z",
    fill: "#e5cd20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_43",
    "data-name": "\\uD0C0\\uC6D0 43",
    cx: 12.913,
    cy: 4.647,
    rx: 12.913,
    ry: 4.647,
    transform: "translate(474.84 6637.287)",
    fill: "#e5cd20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_656",
    "data-name": "\\uC0AC\\uAC01\\uD615 656",
    width: 7.152,
    height: 3.065,
    transform: "translate(503.59 6652.152) rotate(180)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3156",
    "data-name": "\\uD328\\uC2A4 3156",
    d: "M499.838,6647.226l4.694.938a.209.209,0,0,1,.167.2v4.332a.208.208,0,0,1-.167.2l-4.694.939a.208.208,0,0,1-.248-.2v-6.209A.207.207,0,0,1,499.838,6647.226Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_44",
    "data-name": "\\uD0C0\\uC6D0 44",
    cx: 17.541,
    cy: 17.541,
    r: 17.541,
    transform: "translate(470.143 6607.354)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_45",
    "data-name": "\\uD0C0\\uC6D0 45",
    cx: 14.51,
    cy: 14.51,
    r: 14.51,
    transform: "translate(473.173 6610.384)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_46",
    "data-name": "\\uD0C0\\uC6D0 46",
    cx: 14.305,
    cy: 14.305,
    r: 14.305,
    transform: "translate(473.378 6610.59)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_47",
    "data-name": "\\uD0C0\\uC6D0 47",
    cx: 4.676,
    cy: 4.676,
    r: 4.676,
    transform: "matrix(0.153, -0.988, 0.988, 0.153, 482.345, 6628.798)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_657",
    "data-name": "\\uC0AC\\uAC01\\uD615 657",
    d: "M0,0H23.5a0,0,0,0,1,0,0V2.157a.908.908,0,0,1-.908.908H.908A.908.908,0,0,1,0,2.157V0A0,0,0,0,1,0,0Z",
    transform: "translate(499.503 6647.043) rotate(180)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3157",
    "data-name": "\\uD328\\uC2A4 3157",
    d: "M476,6653.122v-6.079h23.5v6.079a1.073,1.073,0,0,1-1.074,1.073H477.078A1.074,1.074,0,0,1,476,6653.122Z",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_658",
    "data-name": "\\uC0AC\\uAC01\\uD615 658",
    width: 4.78,
    height: 18.097,
    transform: "translate(508.699 6616.027)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_659",
    "data-name": "\\uC0AC\\uAC01\\uD615 659",
    width: 4.78,
    height: 18.097,
    transform: "translate(462.028 6616.027)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_48",
    "data-name": "\\uD0C0\\uC6D0 48",
    cx: 1.607,
    cy: 1.607,
    r: 1.607,
    transform: "translate(499.568 6637.978)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3158",
    "data-name": "\\uD328\\uC2A4 3158",
    d: "M500.525,6638.869l.945-.205.65.716-.295.921-.945.205-.65-.716Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_49",
    "data-name": "\\uD0C0\\uC6D0 49",
    cx: 1.607,
    cy: 1.607,
    r: 1.607,
    transform: "translate(499.568 6608.959)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3159",
    "data-name": "\\uD328\\uC2A4 3159",
    d: "M500.525,6611.282l.945.205.65-.716-.295-.921-.945-.205-.65.716Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_50",
    "data-name": "\\uD0C0\\uC6D0 50",
    cx: 1.607,
    cy: 1.607,
    r: 1.607,
    transform: "translate(472.724 6637.978)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3160",
    "data-name": "\\uD328\\uC2A4 3160",
    d: "M474.982,6638.869l-.945-.205-.65.716.295.921.945.205.65-.716Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_51",
    "data-name": "\\uD0C0\\uC6D0 51",
    cx: 1.607,
    cy: 1.607,
    r: 1.607,
    transform: "translate(472.724 6608.959)",
    fill: "#f7e431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3161",
    "data-name": "\\uD328\\uC2A4 3161",
    d: "M474.982,6611.282l-.945.205-.65-.716.295-.921.945-.205.65.716Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_52",
    "data-name": "\\uD0C0\\uC6D0 52",
    cx: 4.423,
    cy: 4.423,
    r: 4.423,
    transform: "translate(483.26 6620.472)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_660",
    "data-name": "\\uC0AC\\uAC01\\uD615 660",
    width: 1.022,
    height: 7.152,
    transform: "matrix(0.766, 0.643, -0.643, 0.766, 489.661, 6622.008)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1515",
    "data-name": "\\uADF8\\uB8F9 1515"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_661",
    "data-name": "\\uC0AC\\uAC01\\uD615 661",
    width: 0.416,
    height: 1.316,
    transform: "translate(492.471 6651.005) rotate(89.676)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1514",
    "data-name": "\\uADF8\\uB8F9 1514"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_662",
    "data-name": "\\uC0AC\\uAC01\\uD615 662",
    width: 0.416,
    height: 1.316,
    transform: "translate(495.201 6648.764) rotate(180)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_663",
    "data-name": "\\uC0AC\\uAC01\\uD615 663",
    width: 0.416,
    height: 1.316,
    transform: "translate(492.469 6650.477) rotate(89.676)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_664",
    "data-name": "\\uC0AC\\uAC01\\uD615 664",
    width: 0.416,
    height: 1.316,
    transform: "translate(493.763 6649.04) rotate(140.001)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_665",
    "data-name": "\\uC0AC\\uAC01\\uD615 665",
    width: 0.416,
    height: 1.316,
    transform: "translate(493.358 6649.38) rotate(140.001)",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_666",
    "data-name": "\\uC0AC\\uAC01\\uD615 666",
    width: 0.416,
    height: 1.316,
    transform: "translate(492.474 6651.533) rotate(89.676)",
    fill: "#58595b"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_53",
    "data-name": "\\uD0C0\\uC6D0 53",
    cx: 2.154,
    cy: 2.154,
    r: 2.154,
    transform: "translate(492.839 6649.087)",
    fill: "#4386ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1516",
    "data-name": "\\uADF8\\uB8F9 1516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3162",
    "data-name": "\\uD328\\uC2A4 3162",
    d: "M493.505,6649.79l2.659,3.168a2.1,2.1,0,0,1-.512.254l-2.486-2.963A2.052,2.052,0,0,1,493.505,6649.79Z",
    fill: "#51a2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3163",
    "data-name": "\\uD328\\uC2A4 3163",
    d: "M494.334,6649.269l2.486,2.963a2.068,2.068,0,0,1-.338.459l-2.658-3.169A2.063,2.063,0,0,1,494.334,6649.269Z",
    fill: "#51a2e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1520",
    "data-name": "\\uADF8\\uB8F9 1520"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3164",
    "data-name": "\\uD328\\uC2A4 3164",
    d: "M481.235,6620.989l5.873,4.04-4.039,5.873.7.485,4.039-5.874,5.873,4.04.485-.705-5.873-4.039,4.039-5.874-.7-.485-4.039,5.874-5.873-4.039Z",
    fill: "#4386ba"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3165",
    "data-name": "\\uD328\\uC2A4 3165",
    d: "M482.978,6631.791a8.34,8.34,0,1,0-2.146-11.6A8.339,8.339,0,0,0,482.978,6631.791Zm8.563-12.452a6.772,6.772,0,1,1-9.417,1.742A6.772,6.772,0,0,1,491.541,6619.339Z",
    fill: "#51a2e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1518",
    "data-name": "\\uADF8\\uB8F9 1518",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3166",
    "data-name": "\\uD328\\uC2A4 3166",
    d: "M487.729,6631.689a6.771,6.771,0,1,0,.079-13.541,6.771,6.771,0,0,1-.079,13.541Z",
    fill: "#c2c2c2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3167",
    "data-name": "\\uD328\\uC2A4 3167",
    d: "M482.978,6631.791a8.3,8.3,0,0,0,4.737,1.467,8.34,8.34,0,0,1,.108-16.679,8.341,8.341,0,0,0-4.845,15.212Z",
    fill: "#c2c2c2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1519",
    "data-name": "\\uADF8\\uB8F9 1519",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3168",
    "data-name": "\\uD328\\uC2A4 3168",
    d: "M487.336,6618.149a6.771,6.771,0,1,0-.038,13.539,6.771,6.771,0,0,1,.038-13.539Z",
    fill: "#454545"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3169",
    "data-name": "\\uD328\\uC2A4 3169",
    d: "M491.918,6618.047a8.339,8.339,0,0,1-4.634,15.21,8.339,8.339,0,1,0,.067-16.676A8.287,8.287,0,0,1,491.918,6618.047Z",
    fill: "#454545"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_54",
    "data-name": "\\uD0C0\\uC6D0 54",
    cx: 1.141,
    cy: 1.141,
    r: 1.141,
    transform: "translate(486.563 6623.778)",
    fill: "#51a2e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3170",
    "data-name": "\\uD328\\uC2A4 3170",
    d: "M487.7,6626.059h.03a1.14,1.14,0,0,1,0-2.278l-.03,0a1.141,1.141,0,0,0,0,2.281Z",
    fill: "#c2c2c2",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3171",
    "data-name": "\\uD328\\uC2A4 3171",
    d: "M488.673,6624.919a1.14,1.14,0,0,1-1.055,1.136c.028,0,.057,0,.085,0a1.141,1.141,0,1,0,0-2.281c-.028,0-.057,0-.085,0A1.14,1.14,0,0,1,488.673,6624.919Z",
    fill: "#454545",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1531",
    "data-name": "\\uADF8\\uB8F9 1531",
    transform: "translate(-255.529 -6345.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1522",
    "data-name": "\\uADF8\\uB8F9 1522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3172",
    "data-name": "\\uD328\\uC2A4 3172",
    d: "M441.714,6512.958c0,2.892,8.736,5.237,19.513,5.237s19.512-2.345,19.512-5.237-8.735-5.237-19.512-5.237S441.714,6510.066,441.714,6512.958Z",
    fill: "#242b52",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3173",
    "data-name": "\\uD328\\uC2A4 3173",
    d: "M450.331,6513.232c0,1.928,6.552,3.491,14.635,3.491s14.635-1.563,14.635-3.491-6.552-3.491-14.635-3.491S450.331,6511.3,450.331,6513.232Z",
    fill: "#242b52",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1529",
    "data-name": "\\uADF8\\uB8F9 1529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1525",
    "data-name": "\\uADF8\\uB8F9 1525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1524",
    "data-name": "\\uADF8\\uB8F9 1524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3174",
    "data-name": "\\uD328\\uC2A4 3174",
    d: "M478.738,6505.968v7.149c0,.634-1.107,1.268-3.32,1.751a44.644,44.644,0,0,1-16.027,0c-2.213-.483-3.32-1.117-3.32-1.751v-7.149Z",
    fill: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1523",
    "data-name": "\\uADF8\\uB8F9 1523",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_667",
    "data-name": "\\uC0AC\\uAC01\\uD615 667",
    width: 6.12,
    height: 11.918,
    transform: "translate(463.743 6516.921) rotate(-180)",
    fill: "#242b52",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_668",
    "data-name": "\\uC0AC\\uAC01\\uD615 668",
    width: 6.12,
    height: 11.918,
    transform: "translate(477.185 6516.921) rotate(-180)",
    fill: "#fff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_55",
    "data-name": "\\uD0C0\\uC6D0 55",
    cx: 11.333,
    cy: 2.476,
    rx: 11.333,
    ry: 2.476,
    transform: "translate(456.071 6503.493)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1528",
    "data-name": "\\uADF8\\uB8F9 1528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1527",
    "data-name": "\\uADF8\\uB8F9 1527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3176",
    "data-name": "\\uD328\\uC2A4 3176",
    d: "M474.774,6487.3v18.615c0,.412-.719.824-2.158,1.138a29,29,0,0,1-10.423,0c-1.439-.314-2.158-.726-2.158-1.138V6487.3Z",
    fill: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1526",
    "data-name": "\\uADF8\\uB8F9 1526",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_669",
    "data-name": "\\uC0AC\\uAC01\\uD615 669",
    width: 3.98,
    height: 21.716,
    transform: "translate(465.024 6508.384) rotate(-180)",
    fill: "#242b52",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_670",
    "data-name": "\\uC0AC\\uAC01\\uD615 670",
    width: 3.98,
    height: 21.716,
    transform: "translate(473.765 6508.384) rotate(-180)",
    fill: "#fff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_56",
    "data-name": "\\uD0C0\\uC6D0 56",
    cx: 7.37,
    cy: 1.61,
    rx: 7.37,
    ry: 1.61,
    transform: "translate(460.035 6485.686)",
    fill: "#e6e7e8"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3178",
    "data-name": "\\uD328\\uC2A4 3178",
    d: "M425.256,6504.932l-41.936-71.243.852-2.59,41.936,71.242Z",
    fill: "#9fa8b6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3179",
    "data-name": "\\uD328\\uC2A4 3179",
    d: "M497.385,6406.369,384.172,6431.1l41.936,71.242,113.213-24.729Z",
    fill: "#d0d2d3"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1530",
    "data-name": "\\uADF8\\uB8F9 1530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3180",
    "data-name": "\\uD328\\uC2A4 3180",
    d: "M441.875,6419.837l54.32-11.866,13.189,22.4-54.321,11.866Zm26.813,45.552,54.321-11.866-13.188-22.4L455.5,6442.984Zm-68.737-11.109,54.32-11.865-13.188-22.405-54.321,11.865Zm13.711,23.294,54.321-11.865-13.189-22.4-54.32,11.865Zm68.749,11.127,54.32-11.866-13.188-22.4L469.222,6466.3ZM427.3,6500.739l54.32-11.865-13.188-22.4-54.32,11.866Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3181",
    "data-name": "\\uD328\\uC2A4 3181",
    d: "M489.978,6410.569l4.83-1.055.943.367L498,6413.7l-.344.648-4.83,1.056-.943-.368-2.245-3.815Zm-6.833,2.066,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.245,3.816.943.367,4.83-1.055.345-.649-2.246-3.815-.943-.368L477,6413.4Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.943-.367-4.83,1.055Zm48.44-4.8,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.056.345-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm48.44-4.8,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm48.44-4.8,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm50-2.151,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm48.44-4.8,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056ZM467.342,6448l2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm48.44-4.8,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm48.44-4.8,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.367-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.367,4.83-1.055.344-.649L473,6458.327l-.942-.368-4.831,1.056Zm-32.366-36.407,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm48.44-4.8,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm48.44-4.8,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.367,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.367,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm48.44-4.8,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.367,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.831,1.055Zm50.084-2.005,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.056.345-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.368,4.83-1.056.345-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649L421.9,6452.3l-.943-.368-4.83,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm48.44-4.8,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.368,4.831-1.056.344-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm48.44-4.8,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm48.44-4.8,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368L412.2,6471.2Zm105.12-14.172,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055ZM504,6460.511l2.246,3.816.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm48.44-4.8,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.368,4.831-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm48.44-4.8,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.368,4.83-1.056.344-.648-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.367,4.83-1.055.344-.649L490.2,6475.1l-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm48.44-4.8,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.056Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.417,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.816-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.368,4.83-1.056.344-.648L499.7,6478.8l-.943-.367-4.831,1.055Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.943.367,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.056Zm-18.741-13.26,2.246,3.815.943.368,4.83-1.055.344-.649-2.246-3.815-.942-.368-4.831,1.055Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649L461.5,6469.8l-.942-.367-4.831,1.055Zm-6.489,1.417,2.246,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.831,1.055Zm-6.489,1.417,2.246,3.816.943.368,4.83-1.056.344-.648-2.245-3.816-.943-.367-4.831,1.055Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.488,1.417,2.245,3.816.943.367,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.245,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm48.439-4.8,2.246,3.815.943.368,4.83-1.055.344-.649L471,6473.5l-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.943.368,4.83-1.055.344-.649-2.245-3.816-.943-.367-4.83,1.055Zm-6.488,1.417,2.245,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.056.344-.648-2.245-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.245,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.245,3.816.943.367,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm48.44-4.8,2.245,3.816.943.367,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.245,3.815.943.368,4.83-1.055.344-.649-2.245-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.056.345-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.246,3.816.942.367,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.056Zm48.44-4.8,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.245,3.816.943.367,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.056Zm-6.489,1.418,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.417,2.245,3.815.943.368,4.83-1.055.345-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.83-1.055.345-.649-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Zm-6.489,1.418,2.246,3.815.942.368,4.831-1.056.344-.648-2.246-3.816-.943-.367-4.83,1.055Zm-6.489,1.417,2.246,3.815.942.368,4.831-1.055.344-.649-2.246-3.815-.943-.368-4.83,1.055Z",
    fill: "#1c75bc"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3182",
    "data-name": "\\uD328\\uC2A4 3182",
    d: "M497.385,6406.369,384.172,6431.1l155.149,46.513Z",
    fill: "#fff",
    opacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3183",
    "data-name": "\\uD328\\uC2A4 3183",
    d: "M538.513,6480.071l-113.256,24.861.852-2.591,113.213-24.729Z",
    fill: "#9fa8b6"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3184",
    "data-name": "\\uD328\\uC2A4 3184",
    d: "M917.529,6489.195v-11H872.085a5.556,5.556,0,0,0-5.556,5.556v38.888a5.555,5.555,0,0,0,5.556,5.556h45.444v-11H883.085a5.555,5.555,0,0,1-5.556-5.556v-16.888a5.556,5.556,0,0,1,5.556-5.556Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#bfbfbf"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3185",
    "data-name": "\\uD328\\uC2A4 3185",
    d: "M819.529,6568.195h-40v11h34.445a5.555,5.555,0,0,1,5.555,5.556v29.888a5.555,5.555,0,0,1-5.555,5.556H779.529v11h45.445a5.555,5.555,0,0,0,5.555-5.556v-51.888a5.555,5.555,0,0,0-5.555-5.556Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#bfbfbf"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1532",
    "data-name": "\\uADF8\\uB8F9 1532",
    transform: "translate(-255.529 -6345.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3186",
    "data-name": "\\uD328\\uC2A4 3186",
    d: "M820.831,6586.918h0a1.947,1.947,0,0,1,.2-.889c1.525-2.978,6.708-2.983,8.775-1.959a.926.926,0,0,1-.06,1.666c-4.8,2.106-8.219-1.927-8.219-1.927v-5.753a4.361,4.361,0,0,0-4.361-4.361H779.529",
    fill: "none",
    stroke: "#7c7c7c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3187",
    "data-name": "\\uD328\\uC2A4 3187",
    d: "M820.844,6586.673l-.013.245a5.14,5.14,0,0,0,1.467,1.781,6.884,6.884,0,0,0,7.19.956.915.915,0,0,0,.039-1.653c-1.969-.979-6.722-.71-8.475,1.931a2.158,2.158,0,0,0-.29,1.61h0a2.284,2.284,0,0,0,.3.758,5.075,5.075,0,0,0,1.238,1.372,6.884,6.884,0,0,0,7.19.956.915.915,0,0,0,.039-1.653c-1.969-.979-6.722-.71-8.475,1.931a2.158,2.158,0,0,0-.29,1.61h0a2.284,2.284,0,0,0,.3.758,5.06,5.06,0,0,0,1.238,1.372,6.887,6.887,0,0,0,7.19.957.916.916,0,0,0,.039-1.654c-1.969-.979-6.722-.71-8.475,1.931a2.16,2.16,0,0,0-.29,1.61h0a2.288,2.288,0,0,0,.3.758,5.067,5.067,0,0,0,1.238,1.372,6.887,6.887,0,0,0,7.19.957.916.916,0,0,0,.039-1.654c-1.969-.979-6.722-.71-8.475,1.931a2.159,2.159,0,0,0-.29,1.61h0a2.286,2.286,0,0,0,.3.758,5.075,5.075,0,0,0,1.238,1.372,6.888,6.888,0,0,0,7.142.978.935.935,0,0,0,.085-1.675c-1.775-.882-5.808-.75-7.871,1.216a3.258,3.258,0,0,0-.91,2.727v.006a3.346,3.346,0,0,0,.748,1.78,4.986,4.986,0,0,0,.8.772,6.888,6.888,0,0,0,7.142.977.935.935,0,0,0,.085-1.675c-2.17-1.078-7.712-.642-8.908,2.808v4.251a4.361,4.361,0,0,1-4.361,4.361H779.529",
    fill: "none",
    stroke: "#7c7c7c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1533",
    "data-name": "\\uADF8\\uB8F9 1533",
    transform: "translate(-255.529 -6345.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3188",
    "data-name": "\\uD328\\uC2A4 3188",
    d: "M877.158,6514.842h0a1.759,1.759,0,0,1-.182.8c-1.373,2.681-6.041,2.686-7.9,1.764a.835.835,0,0,1,.068-1.506c4.318-1.883,7.387,1.741,7.387,1.741v.71a4.342,4.342,0,0,0,4.343,4.343H917.12",
    fill: "none",
    stroke: "#7c7c7c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3189",
    "data-name": "\\uD328\\uC2A4 3189",
    d: "M877.146,6515.063l.012-.221a4.634,4.634,0,0,0-1.321-1.6,6.2,6.2,0,0,0-6.457-.87.829.829,0,0,0-.054,1.5c1.773.882,6.054.64,7.633-1.738a1.945,1.945,0,0,0,.261-1.45h0a2.034,2.034,0,0,0-.268-.683,4.586,4.586,0,0,0-1.115-1.236,6.2,6.2,0,0,0-6.457-.869.829.829,0,0,0-.054,1.5c1.773.883,6.054.641,7.633-1.738a1.942,1.942,0,0,0,.261-1.449h0a2.026,2.026,0,0,0-.268-.683,4.586,4.586,0,0,0-1.115-1.236,6.2,6.2,0,0,0-6.457-.869.829.829,0,0,0-.054,1.5c1.773.882,6.054.641,7.633-1.738a1.944,1.944,0,0,0,.261-1.45h0a2.042,2.042,0,0,0-.268-.683,4.582,4.582,0,0,0-1.115-1.235,6.2,6.2,0,0,0-6.457-.869.829.829,0,0,0-.054,1.5c1.773.882,6.054.64,7.633-1.738a1.945,1.945,0,0,0,.261-1.45h0a2.034,2.034,0,0,0-.268-.683,4.586,4.586,0,0,0-1.115-1.236,6.2,6.2,0,0,0-6.42-.885.844.844,0,0,0-.088,1.514,7.313,7.313,0,0,0,7.088-1.1,2.931,2.931,0,0,0,.819-2.455v-.006a3.026,3.026,0,0,0-.674-1.6,4.528,4.528,0,0,0-.725-.694,6.2,6.2,0,0,0-6.42-.885.843.843,0,0,0-.088,1.513c1.953.97,6.945.578,8.021-2.529v-.157a4.343,4.343,0,0,1,4.343-4.343h35.836",
    fill: "none",
    stroke: "#7c7c7c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC785\\uAD6C",
    transform: "translate(815.229 205.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC785\uAD6C"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "\\uCD9C\\uAD6C",
    transform: "translate(815.229 125.175)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCD9C\uAD6C"))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_671",
    "data-name": "\\uC0AC\\uAC01\\uD615 671",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(581 113)",
    fill: "#fff"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "T3",
    transform: "translate(589.053 121.698)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T3"))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_672",
    "data-name": "\\uC0AC\\uAC01\\uD615 672",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(581 305)",
    fill: "#fff"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "T4",
    transform: "translate(589.053 313.698)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T4"))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3190",
    "data-name": "\\uD328\\uC2A4 3190",
    d: "M301.126,6545.195l-9.152-14.5-9.391,14.5Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#0071bc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3191",
    "data-name": "\\uD328\\uC2A4 3191",
    d: "M629.529,6615.923l-14.5,9.152,14.5,9.391Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#0071bc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3192",
    "data-name": "\\uD328\\uC2A4 3192",
    d: "M309.529,6465.966l14.5-9.151-14.5-9.392Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#0071bc"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_673",
    "data-name": "\\uC0AC\\uAC01\\uD615 673",
    width: 34,
    height: 16,
    transform: "translate(77 103.5)",
    fill: "#e6e6e6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_674",
    "data-name": "\\uC0AC\\uAC01\\uD615 674",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(81 106.5)",
    fill: "#fff"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "T1",
    transform: "translate(89.053 115.198)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T1"))), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_675",
    "data-name": "\\uC0AC\\uAC01\\uD615 675",
    width: 34,
    height: 16,
    transform: "translate(289 104)",
    fill: "#e6e6e6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_676",
    "data-name": "\\uC0AC\\uAC01\\uD615 676",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(293 107)",
    fill: "#fff"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "T2",
    transform: "translate(301.053 115.698)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T2"))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3193",
    "data-name": "\\uD328\\uC2A4 3193",
    d: "M622.529,6466.021l14.5-9.151-14.5-9.392Z",
    transform: "translate(-255.529 -6345.195)",
    fill: "#f44522"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder3);
export default __webpack_public_path__ + "static/media/placeholder3.5c64473a9b87e9dc5f78d78f9f46780e.svg";
export { ForwardRef as ReactComponent };